import React, { useEffect } from "react";
import { Grid2 } from "@mui/material";
import { useSetState } from "Utils/Helpers/Hooks";
import Inputer from "Utils/Helpers/Inputer";
import MButton from "Utils/Helpers/MButton";
import MuiRadioGroup from "Utils/Helpers/MuiRadioGroup";
import * as Icons from "react-bootstrap-icons";
import OpenSee from "../../../../../Utils/Assets/Images/opensee.svg";
import Rari from "../../../../../Utils/Assets/Images/Rari.svg";
import { useDispatch } from "react-redux";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import { enqueueSnackbar } from "notistack";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { setSocialData } from "../../../../../Redux/slices/mngrSlice";
import { post_social } from "http/components/Social";

export default function AddSocialData() {
  const dispatch = useDispatch();
  const [controls, setControls] = useSetState({
    name: {
      label: "Name",
      type: "text",
      multiLine: false,
      placeholder: "Enter name",
      value: "",
      validation: false,
    },
    link: {
      label: "Link",
      type: "text",
      multiLine: false,
      placeholder: "Enter link",
      value: "",
      validation: false,
    },
    icon: {
      label: "Icon",
      type: "radio",
      value: "",
      items: [
        { key: <Icons.Whatsapp />, value: "Whatsapp" },
        { key: <Icons.Telegram />, value: "Telegram" },
        { key: <Icons.Instagram />, value: "Instagram" },
        { key: <Icons.Facebook />, value: "Facebook" },
        { key: <Icons.Discord />, value: "Discord" },
        { key: <Icons.Reddit />, value: "Reddit" },
        { key: <Icons.Medium />, value: "Medium" },
        { key: <Icons.Threads />, value: "Threads" },
        { key: <Icons.Youtube />, value: "Youtube" },
        { key: <Icons.TwitterX />, value: "TwitterX" },
        { key: <Icons.EnvelopePaper />, value: "Email" },
        { key: <img src={OpenSee} />, value: "OpenSee" },
        { key: <img src={Rari} />, value: "Rarible" },
      ],
    },
  });

  useEffect(() => {
    onClear();
  }, []);

  const onClear = () => {
    setControls({ name: { value: "", validation: false } });
    setControls({ icon: { value: controls.icon.items[0] } });
    setControls({ link: { value: "", validation: false } });
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value, validation } });
  };

  const onChangeRadio = (name, value) => {
    setControls({ [name]: { value: value } });
  };

  const onSubmit = async () => {
    const { name, icon, link } = controls;
    if (name.validation && link.validation && icon.value) {
      dispatch(HandleLoading(true));
      const response = await post_social({
        name: name.value,
        link: link.value,
        icon: icon.value.value,
      });
      if (CheckApiStatus(response)) {
        onClear();
        dispatch(setSocialData(true));
        enqueueSnackbar("Insert Success", { variant: "success" });
      }
      dispatch(HandleLoading(false));
    } else {
      enqueueSnackbar("Enter data correctly", { variant: "error" });
    }
  };

  return (
    <Grid2 container spacing={2}>
      {Object.keys(controls).map((key, index) => {
        return (
          <Grid2 size={{ xs: 12 }} key={key + index}>
            {controls[key].type === "text" && (
              <Inputer
                id={key}
                setValue={setValue.bind(this)}
                value={controls[key].value}
                label={controls[key].label}
                placeholder={controls[key].placeholder}
                type={controls[key].type}
                multiLine={controls[key].multiLine}
              />
            )}
            {controls[key].type === "radio" && (
              <MuiRadioGroup
                name={key}
                value={controls[key].value}
                label={controls[key].label}
                items={controls[key].items}
                onChange={onChangeRadio}
                classname="icon-items"
              />
            )}
          </Grid2>
        );
      })}
      <Grid2 size={{ xs: 12 }}>
        <MButton label={"Save"} onClick={onSubmit} />
      </Grid2>
    </Grid2>
  );
}
